import { Err } from "@siteimprove/alfa-result";
/**
 * {@link https://drafts.csswg.org/css-values/#calculation-tree}
 *
 * @public
 */
export class Expression {
    _type;
    _kind;
    constructor(type, kind) {
        this._type = type;
        this._kind = kind;
    }
    get type() {
        return this._type;
    }
    get kind() {
        return this._kind;
    }
    toAngle() {
        return Err.of(`${this} is not a reduced angle`);
    }
    toLength() {
        return Err.of(`${this} is not a reduced length`);
    }
    toNumber() {
        return Err.of(`${this} is not a reduced number`);
    }
    toPercentage() {
        return Err.of(`${this} is not a reduced percentage`);
    }
    toJSON() {
        return {
            type: this.type,
        };
    }
}
//# sourceMappingURL=expression.js.map